import HttpService from "./HttpService";

let escolaService = {
    buscarListaDeEscolas: () => {
        return HttpService.backApi.get("/escola/lista");
    },

    deletarEscola: (id) => {
        return HttpService.backApi.delete(`/escola/${id}`)
    },

    salvarEscola: (escola) => {
        return HttpService.backApi.post('/escola/create', escola)
    },

    atualizarEscola: (escola) => {
        return HttpService.backApi.put('/escola/update', escola)
    }
};

export default escolaService;
